import { SPARECORES_PROVIDERS } from "../seo/priceSources";

export { SPARECORES_PROVIDERS };

/** Prix d'AWS, de Google Cloud et d'UpCloud : relevés par Spare Cores (CC BY-SA 4.0). La licence demande
 *  de citer la source et de partager ces prix sous la même licence (data/gpu-prices.json est public). */
export function SpareCoresCredit() {
  return (
    <p className="vram-footnote">
      {Object.values(SPARECORES_PROVIDERS).join(", ").replace(/, ([^,]*)$/, " and $1")} prices:{" "}
      <a className="vram-link" href="https://sparecores.com" target="_blank" rel="noopener noreferrer">Spare Cores<span className="sr-only"> (opens in a new tab)</span></a>,{" "}
      <a className="vram-link" href="https://creativecommons.org/licenses/by-sa/4.0/" target="_blank" rel="noopener noreferrer">CC BY-SA 4.0<span className="sr-only"> (opens in a new tab)</span></a>,
      shared under the same license.
    </p>
  );
}
